import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import BtnPink from '../../../../Shared/Buttons/BtnPink';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import './PopUpRouterWifi.scss';



export const PopUpRouterWifi = (props) => {
  if(props.routerInfo === undefined) return null;
  const {
    routerInfo,
    setShowPopUpRouter,
    isShowPopUpRouterSlice,
    saleType,
    flowType,
    addRouterWifiStarPro,
    reportDWH
  } = props;

  const {
    buttonTextContinue,
    buttonTextUpgrade,
    imagePopUpRouter,
    textRouterExplanation,
    titleSecPopUpRouter,
    textMainProgram,
    titleMainPopUpRouter,
    textSecPopUpRouter,
    linkMainProgram,
    linkRouterRouterExplanation
   } = routerInfo;

   useEffect(()=> {
    gtag4({event: `${saleType}_Step5_UpgradeRouterPage`, step: '5', action: 'UpgradeRouterPage', funnel_name: `${saleType}_Exists${flowType}_Customer`});
    reportDWH({ actionType: 'Router Upgrade', status: 'Ongoing', messageText: 'Router Upgrade Display' });

  },[]);

  const handleUpgrade = async ()=>{
    await addRouterWifiStarPro();
    gtag4({event: `${saleType}_Step5_UpgradeRouterYes`, step: '5', button: buttonTextUpgrade.value, action: 'UpgradeRouterYes', funnel_name: `${saleType}_Exists${flowType}_Customer`});
    reportDWH({ actionType: 'Router Upgrade', status: 'Ongoing', messageText: 'Router Upgrade Clicked Yes' });
    setShowPopUpRouter(false);
  };

  const handleContinue = ()=>{
    setShowPopUpRouter(false);
    gtag4({event: `${saleType}_Step5_UpgradeRouterNo`, step: '5', button: buttonTextContinue.value, action: 'UpgradeRouterNo', funnel_name: `${saleType}_Exists${flowType}_Customer` });
    reportDWH({ actionType: 'Router Upgrade', status: 'Ongoing', messageText: 'Router Upgrade Clicked No' });
  };


  return (
    <PopUp
    showPopUp={isShowPopUpRouterSlice}
    onClose={() => setShowPopUpRouter(false)}
    className='pop-up-router-wifi'
   >
    <div className='router-wifi-wrapper'>
      {imagePopUpRouter.value?.url && <Image src={Config.epiBaseUrl + imagePopUpRouter.value?.url} alt="image-pop-up" />}
      <div className='info-pop-up'>
        {titleMainPopUpRouter.value && (
        <div className='wrapper-titles'>
         {titleMainPopUpRouter.value && <h1 dangerouslySetInnerHTML={{ __html: titleMainPopUpRouter.value }}></h1>}
         {
          titleSecPopUpRouter.value && (
          <div className='sub-title'>
            <h1 dangerouslySetInnerHTML={{ __html: titleSecPopUpRouter.value }}></h1>
            <span>₪</span>
          </div>
          )
         }
        </div>
        )}
        {textSecPopUpRouter.value &&<div className='text-popup' dangerouslySetInnerHTML={{ __html: textSecPopUpRouter.value }}></div>}
        <div className='linkes'>
          {textRouterExplanation.value && <a href='#' onClick={(e)=> {e.preventDefault(); buildUrlAndOpenWindow(linkRouterRouterExplanation.value)}}> {textRouterExplanation.value}</a>}
          {textMainProgram.value && <a href='#' onClick={(e)=> {e.preventDefault(); buildUrlAndOpenWindow(linkMainProgram.value)}}> {textMainProgram.value }</a>}
        </div>
      </div>
      <div className='popup-btn-wrapper'>
        {buttonTextUpgrade.value && <BtnPink text={buttonTextUpgrade.value} onclick={handleUpgrade} />}
        {buttonTextContinue.value && <BtnWhite text={buttonTextContinue.value} onclick={handleContinue} />}
      </div>
    </div>
    </PopUp>
  )
};
